import React from 'react'
import _, { get } from 'lodash'
import styled from 'styled-components'
import { SectionStyle } from '../index.styled'
import { HSDSpiderGraph } from '../components/HSDSpiderGraph'
import classNames from 'classnames'
import { VictoryPie } from 'victory'
import { FlexBox } from '../../commonComponents/FlexBox'
import { useInView } from 'react-intersection-observer'
import { Divider, Space } from 'antd-mobile'

const Container = styled.section`
  ${SectionStyle}

  .note {
    flex-grow: 1;
    margin-bottom: 60px;
  }

  button {
    margin-left: 40px;
  }

  .graph-container {
    margin-top: 20px;
  }
`

export function HealthCompassSection(props) {
  const { dataList, dynamicData, visible } = props

  const { ref } = useInView({
    threshold: 0.1,
    onChange: (inView) => {
      if (inView) {
        visible()
      }
    }
  })

  return (
    <Container ref={ref}>
      <h1 className="ar-section-title">Health Compass</h1>
      <div className="graph-container">
        <HSDSpiderGraph dataList={dataList} />
      </div>
      <ScoreBreakdown
        {...get(dynamicData, 'lifeStyleSummary.lifestyleScore')}
      />
    </Container>
  )
}

const ScoreBreakdownContainer = styled.div`
  font-weight: 600;
  .qqt-card {
    border: 1px solid rgba(227, 230, 234, 1);
    background-color: rgba(250, 250, 250, 1);
    padding: 24px;
    margin-bottom: 18px;
    .pillar-status {
      width: 130px;
      .pillar-name-label {
        font-size: 20px;
        margin-bottom: 8px;
        margin-top: -12px;
        color: rgba(50, 63, 74, 1);
      }
      .pillar-status-label {
        font-size: 15px;
        padding: 5px 13px;
        color: white;
        border-radius: 6px;
        background-color: lightgray;
        &.fair {
          background-color: rgba(245, 186, 64, 1);
        }
        &.optimal {
          background-color: rgba(64, 196, 124, 1);
        }
        &.poor {
          background-color: rgba(255, 107, 0, 1);
        }
      }
    }
    .pie {
      width: 130px;
      position: relative;
      .pillar-score-label {
        color: rgba(50, 63, 74, 1);
        font-size: 24px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .ant-divider-horizontal {
      margin-top: 0px;
    }
    .qqt-title-label {
      color: rgba(76, 96, 114, 1);
      font-size: 15px;
    }
    .qqt-status-label {
      font-size: 15px;
      font-weight: 600;

      &.fair {
        color: rgba(245, 186, 64, 1);
      }
      &.optimal {
        color: rgba(64, 196, 124, 1);
      }
      &.poor {
        color: rgba(255, 107, 0, 1);
      }
    }
  }
`

const ScoreBreakdown = (props) => {
  const level = {
    1: 'poor',
    2: 'fair',
    3: 'optimal'
  }

  const pillars = ['exercise', 'nutrition', 'sleep']

  return (
    <ScoreBreakdownContainer>
      <h2
        className="ar-section-group-title"
        style={{
          marginBottom: 16
        }}
      >
        Score Breakdown
      </h2>
      <div>
        {pillars.map((pillar, index) => {
          const pillarScore = get(props, `${pillar}.score.total`)
          const pillarLevel = get(props, `${pillar}.level.total`)
          const quantity = get(props, `${pillar}.level.quantity`)
          const quality = get(props, `${pillar}.level.quality`)
          const timing = get(props, `${pillar}.level.timing`)
          return (
            <div key={index}>
              <div className="qqt-card">
                <FlexBox justifyContent="space-between" alignItems="center">
                  <div className="pillar-status">
                    <div className="pillar-name-label">
                      {_.capitalize(pillar)}
                    </div>
                    <span
                      className={classNames(
                        'pillar-status-label',
                        pillarLevel && level[pillarLevel]
                      )}
                    >
                      {pillarLevel ? _.capitalize(level[pillarLevel]) : '-'}
                    </span>
                  </div>
                  <div className="pie">
                    <VictoryPie
                      innerRadius={110}
                      data={[quantity, quality, timing].map((l) => {
                        switch (l) {
                          case 1:
                            return { x: 'AT RISK', y: 1, color: '#FF6B00' }
                          case 2:
                            return { x: 'CONCERN', y: 1, color: '#F5BA40' }
                          case 3:
                            return { x: 'OPTIMAL', y: 1, color: '#40C47C' }
                          default:
                            return { x: 'N/A', y: 1, color: 'lightgray' }
                        }
                      })}
                      style={{
                        labels: { fill: 'transparent' },
                        data: {
                          fill: ({ datum }) => datum.color
                        }
                      }}
                    />
                    <div className={classNames('pillar-score-label')}>
                      {pillarScore || '--'}
                    </div>
                  </div>
                </FlexBox>
                <Divider />
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                  <FlexBox justifyContent="space-between">
                    <span className="qqt-title-label">Quantity</span>
                    <span
                      className={classNames(
                        'qqt-status-label',
                        (quantity && level[quantity]) || ''
                      )}
                    >
                      {_.capitalize(quantity && level[quantity]) || '-'}
                    </span>
                  </FlexBox>
                  <FlexBox justifyContent="space-between">
                    <span className="qqt-title-label">Quality</span>
                    <span
                      className={classNames(
                        'qqt-status-label',
                        (quality && level[quality]) || ''
                      )}
                    >
                      {_.capitalize(quality && level[quality]) || '-'}
                    </span>
                  </FlexBox>
                  <FlexBox justifyContent="space-between">
                    <span className="qqt-title-label">Timing</span>
                    <span
                      className={classNames(
                        'qqt-status-label',
                        (timing && level[timing]) || ''
                      )}
                    >
                      {_.capitalize(timing && level[timing]) || '-'}
                    </span>
                  </FlexBox>
                </Space>
              </div>
            </div>
          )
        })}
      </div>
    </ScoreBreakdownContainer>
  )
}
